import { render } from "./LangRouterLink.vue?vue&type=template&id=a9ede89c"
import script from "./LangRouterLink.vue?vue&type=script&lang=js"
export * from "./LangRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__